import type { UserDetailResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { EditUserForm } from "Settings/User/Components/Form/EditUserForm";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Box } from "@mui/material";

const userFormResources = Resources.base.user;

type UserEditWidgetProps = {
	user: UserDetailResponseDto;
	userId: number;
};

export function UserEditWidget({ user, userId }: UserEditWidgetProps) {
	const { t } = useResource();
	return (
		<BaseCard title={t(userFormResources.edit)}>
			<Box>
				<EditUserForm user={user} userId={userId} />
			</Box>
		</BaseCard>
	);
}
